import moment from 'moment';
// import config from '../config';
import queryApi from './api/queryApi';
/* ACTIONS */

export const OPENSEARCH_ACTIVEUSERPLATFORM = 'OPENSEARCH/ACTIVEUSERPLATFORM';
export const OPENSEARCH_ADIMPRESSIONPLATFORM = 'OPENSEARCH/ADIMPRESSIONPLATFORM';
export const OPENSEARCH_ADIMPRESSIONLOCATION = 'OPENSEARCH/ADIMPRESSIONLOCATION';
export const OPENSEARCH_ADIMPRESSIONID = 'OPENSEARCH/ADIMPRESSIONID';
export const OPENSEARCH_CTACLICKADID = 'OPENSEARCH/CTACLICKADID';
export const OPENSEARCH_ADIMPRESSIONAPP = 'OPENSEARCH/ADIMPRESSIONAPP';
export const OPENSEARCH_ADIMPRESSIONUSERLOCATION = 'OPENSEARCH/ADIMPRESSIONUSERLOCATION';

export const SPICONFIG_LIST = 'SPICONFIG/LIST';
export const SPICONFIG_UPDATE = 'SPICONFIG/UPDATE';


export const VIEWERSESSION_SETTINGS = 'VIEWERSESSION/SETTINGS';
export const VIEWERSESSION_GETLIST = 'VIEWERSESSION/GETLIST';
export const VIEWERSESSION_GETUSERLIST = 'VIEWERSESSION/GETUSERLIST';
export const VIEWERSESSION_GETFILTERLIST = 'VIEWERSESSION/GETFILTERLIST';
export const VIEWERSESSION_GETSESSIONLIST = 'VIEWERSESSION/GETSESSIONLIST';
export const VIEWERSESSION_GETERRORLIST = 'VIEWERSESSION/GETERRORLIST';
export const INSPECTIONTIME_UPDATE = 'INSPECTIONTIME/UPDATE';
export const INDEPTHFILTER_UPDATE = 'INDEPTHFILTER/UPDATE';

export const ADVERTISEMENT_GETPACKAGE = 'ADVERTISEMENT/GETPACKAGE';
export const ADVERTISEMENT_GETORDER = 'ADVERTISEMENT/GETORDER';
export const ADVERTISEMENT_GETORDERALL = 'ADVERTISEMENT/GETORDERALL';

/* ROUTE API */
// const SPICONFIG_LIST_ROUTE = '/broadcast';

const initialState = {
	viewersessionSettings: {userAccount: "",maxStep:0, currentStep: 0, timerange:[moment().startOf('hour').add(-1,'days').add(1,'hour').toISOString(), moment().startOf('hour').add(1,'hour').toISOString()]},
	inspectionTime: {day:7, till:moment().add(1,'hour').startOf('hour').toISOString()}
};

const getOpenSearchBuckets = (data) => {
	if(data && data.responses && data.responses[0] && data.responses[0].aggregations && data.responses[0].aggregations.results && data.responses[0].aggregations.results.buckets){
		return data.responses[0].aggregations.results.buckets;
	}else{
		return [];
	}
}



export default (state = initialState, action) => {
	switch (action.type) {
		case SPICONFIG_LIST:
			return {
				...state,
				spiconfigList: action.payload,
			};
		case SPICONFIG_UPDATE: // WHENEVER THAT IS UPDATED
			return {
				...state,
				spiCDNList: null
			};
		case INSPECTIONTIME_UPDATE:
			delete state.spiCDNList;
			delete state.indepthFilter;
			delete state.viewersessionFilterList;
			delete state.opensearchActiveUserByPlatformList;
			delete state.opensearchAdImpressionByLocationList;
			delete state.opensearchAdImpressionByPlatformList;
			delete state.opensearchAdImpressionByIdList;
			delete state.opensearchCtaClickByAdIdList;
			delete state.opensearchAdImpressionByAppList;
			delete state.opensearchAdImpressionByUserLocationList;

			return {
				...state,
				inspectionTime: action.payload,
			};
		case VIEWERSESSION_SETTINGS:
			return {
				...state,
				viewersessionSettings: action.payload
			};
		case VIEWERSESSION_GETLIST:
			return {
				...state,
				viewersessionList: action.payload
			};
		case VIEWERSESSION_GETUSERLIST:
			return {
				...state,
				viewersessionUserList: action.payload,
			};
		case VIEWERSESSION_GETFILTERLIST:
			return {
				...state,
				viewersessionFilterList: action.payload,
			};
		case VIEWERSESSION_GETSESSIONLIST:
			return {
				...state,
				viewersessionSessionList: action.payload,
			};
		case VIEWERSESSION_GETERRORLIST:
			return {
				...state,
				viewersessionErrorList: action.payload,
			};
		case OPENSEARCH_ACTIVEUSERPLATFORM:
			return {
				...state,
				opensearchActiveUserByPlatformList: action.payload,
			};
		case OPENSEARCH_ADIMPRESSIONPLATFORM:
			return {
				...state,
				opensearchAdImpressionByPlatformList: action.payload,
			};
		case OPENSEARCH_ADIMPRESSIONLOCATION:
			return {
				...state,
				opensearchAdImpressionByLocationList: action.payload,
			};
		case OPENSEARCH_ADIMPRESSIONID:
			return {
				...state,
				opensearchAdImpressionByIdList: action.payload,
			};
		case OPENSEARCH_CTACLICKADID:
			return {
				...state,
				opensearchCtaClickByAdIdList: action.payload,
			};
		case OPENSEARCH_ADIMPRESSIONAPP:
			return {
				...state,
				opensearchAdImpressionByAppList: action.payload,
			};
		case OPENSEARCH_ADIMPRESSIONUSERLOCATION:
			return {
				...state,
				opensearchAdImpressionByUserLocationList: action.payload,
			};
		case ADVERTISEMENT_GETPACKAGE:
			return {
				...state,
				advertisementPackageList: action.payload,
			};
		case ADVERTISEMENT_GETORDER:
			return {
				...state,
				advertisementOrderList: action.payload,
			};
		case ADVERTISEMENT_GETORDERALL:
			return {
				...state,
				advertisementOrderListAll: action.payload,
			};
		default:
			return state;
	}
};

export const spiconfigGetList = (organization) => {
	return dispatch => {
		return queryApi.get(`/statistic/performanceConfig?account=${organization}`).then(data => {
			dispatch({
				type: SPICONFIG_LIST,
				payload: data
			});
		
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const spiconfigUpdate = (payload, paramStr) => {
	return dispatch => {
		return queryApi.patch(`/statistic/performanceConfig?${paramStr}`, payload).then(data => {
			dispatch({
				type: SPICONFIG_UPDATE
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};




export const indepthFilterUpdate = (data) => {
	return dispatch => {
		dispatch({
			type: INDEPTHFILTER_UPDATE,
			payload: data
		});
	};
};

export const inspectionTimeUpdate = (data) => {
	return dispatch => {
		dispatch({
			type: INSPECTIONTIME_UPDATE,
			payload: data
		});
	};
};

export const viewersessionUpdateSettings = (data) => {
	return dispatch => {
		dispatch({
			type: VIEWERSESSION_SETTINGS,
			payload: data
		});
	};
};

export const viewersessionGetList = (paramStr) => {
	return dispatch => {
		return queryApi.get(`/statistic/listAccountName?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetUserList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return queryApi.get(`/statistic/listViewerSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETUSERLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetFilterList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return queryApi.get(`/statistic/listViewerSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETFILTERLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetSessionList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return queryApi.get(`/statistic?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETSESSIONLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const viewersessionGetErrorList = (paramStr) => {
	return dispatch => {
		// return api.get(`/analytics?account=${organization}&func=getSPIConfig`).then(data => {
		return queryApi.get(`/statistic/listErrorSession?${paramStr}`).then(data => {
			dispatch({
				type: VIEWERSESSION_GETERRORLIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};



export const opensearchActiveUserPlatform = (paramStr) => {
	return dispatch => {
		return queryApi.get(`/query?${paramStr}&type=getActiveUserByPlatform`).then(data => {
			dispatch({
				type: OPENSEARCH_ACTIVEUSERPLATFORM,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchAdImpressionPlatform = (paramStr) => {
	return dispatch => {
		return queryApi.get(`/query?${paramStr}&type=getAdImpressionByPlatform`).then(data => {
			dispatch({
				type: OPENSEARCH_ADIMPRESSIONPLATFORM,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchAdImpressionLocation = (paramStr) => {
	return dispatch => {
		return queryApi.get(`/query?${paramStr}&type=getAdImpressionByLocation`).then(data => {
			dispatch({
				type: OPENSEARCH_ADIMPRESSIONLOCATION,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchAdImpressionId = (paramStr) => {
	return dispatch => {
		return queryApi.get(`/query?${paramStr}&type=getAdImpressionById`).then(data => {
			dispatch({
				type: OPENSEARCH_ADIMPRESSIONID,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchAdImpressionIdSpecific = (paramStr, advid) => {
	return dispatch => {
		return queryApi.get(`/query?${paramStr}&advid=${advid}&type=getImpressionCountByAdvId`).then(data => {
			return getOpenSearchBuckets(data);
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchCtaClickAdId = (paramStr) => {
	return dispatch => {
		return queryApi.get(`/query?${paramStr}&type=getCtaClickByAdId`).then(data => {
			dispatch({
				type: OPENSEARCH_CTACLICKADID,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const opensearchCtaClickAdIdSpecific = (paramStr, advid) => {
	return dispatch => {
		return queryApi.get(`/query?${paramStr}&advid=${advid}&type=getCTAClicksByAdvId`).then(data => {
			return getOpenSearchBuckets(data);
		}).catch(error => {
			throw (error);
		});
	};
};


export const opensearchAdImpressionApp = (paramStr) => {
	return dispatch => {
		return queryApi.get(`/query?${paramStr}&type=getAdImpressionByAppNameVersion`).then(data => {
			dispatch({
				type: OPENSEARCH_ADIMPRESSIONAPP,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const opensearchAdImpressionUserLocation = (paramStr) => {
	return dispatch => {
		return queryApi.get(`/query?${paramStr}&type=getImpressionByUserLocation`).then(data => {
			dispatch({
				type: OPENSEARCH_ADIMPRESSIONUSERLOCATION,
				payload: getOpenSearchBuckets(data)
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const advertisementGetPackage = () => {
	return dispatch => {
		return queryApi.get(`/advertpackage?showAll=true`).then(data => {
			dispatch({
				type: ADVERTISEMENT_GETPACKAGE,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const advertisementGetOrder = () => {
	return dispatch => {
		return queryApi.get(`/advertorder`).then(data => {
			dispatch({
				type: ADVERTISEMENT_GETORDER,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};
export const advertisementGetOrderAll = () => {
	return dispatch => {
		return queryApi.get(`/advertorder?showAll=true`).then(data => {
			dispatch({
				type: ADVERTISEMENT_GETORDERALL,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const advertisementPackageUpdate = (payload, id) => {
	return dispatch => {
		return queryApi.patch(`/advertpackage/`+id, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const advertisementPackageCreate = (payload) => {
	return dispatch => {
		return queryApi.post(`/advertpackage`, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const advertisementPackageDelete = (id) => {
	return dispatch => {
		return queryApi.delete(`/advertpackage/inactive/`+id).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const advertisementOrderUpdate = (payload, id) => {
	return dispatch => {
		return queryApi.patch(`/advertorder/`+id, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};


export const advertisementOrderCreate = (payload) => {
	return dispatch => {
		return queryApi.post(`/advertorder`, payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const advertisementOrderDelete = (id) => {
	return dispatch => {
		return queryApi.delete(`/advertorder/inactive/`+id).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const advertisementUpload = (file, type) => {
	return dispatch => {
		const formData = new FormData();
		formData.append('file', file);
		return queryApi.post(`/advertorder/upload/${type}`, formData).then((data) => {
			return data;
		}).catch((error) => {
			throw error;
		});
	};
}